export default __webpack_public_path__ + "static/media/Walker's Tunic of the Mound.7d0ef79b.jpg";